<script>
export default {
    name: "CashSaleForm",

    data() {

        return {
            tendered: 0
        };
    },

    props: {

        totalBalance: Number,
        cashSale: Object,
        errors: Array,
        cashCOAs: Array,
        cashPModes: Array,
    },

    watch: {

        "cashSale.paymentModeID"() {
            if(!this.cashSale.paymentModeID) return;

            const matchPMs = this.cashPModes.filter(cashPM => 
                cashPM.pmodeID == this.cashSale.paymentModeID);

            this.cashSale.paymentMode = matchPMs.length ? matchPMs[0].mode : ``;
        },

        "cashSale.accountID"() {
            if(!this.cashSale.accountID) return;

            const matchedAccounts = this.cashCOAs.filter(cashPM => 
                cashPM.coaid == this.cashSale.accountID);

            this.cashSale.accountName = matchedAccounts.length ? matchedAccounts[0].coaName : ``;
        },

        totalBalance() {
            this.cashSale.totalCashAmount = this.totalBalance;
        },
    },

    mounted() {
        this.cashSale.totalCashAmount = this.totalBalance;
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <div class="md:w-1/2 sm:w-full p-1">
        <label for="grid-account" class="label-control">Account:</label>
        <tail-select>
            <template v-slot:field>
                <select v-model="cashSale.accountID" id="grid-account" class="input-control input-sm text-xs">
                    <option :value="0">select account</option>
                    <option v-for="(cashCOA, idx) in cashCOAs" :key="idx" :value="cashCOA.coaid">{{ cashCOA.coaName }}</option>
                </select>
            </template>
        </tail-select>
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'accountID').length">
            {{ errors.filter(error => error.field == 'accountID')[0].message }}</p>
    </div>
    <div class="md:w-1/2 sm:w-full p-1">
        <label for="grid-p-mode" class="label-control">P.Mode:</label>
        <tail-select>
            <template v-slot:field>
                <select v-model="cashSale.paymentModeID" id="grid-p-mode" class="input-control input-sm text-xs">
                    <option :value="0">select payment mode</option>
                    <option v-for="(cashPMode, idx) in cashPModes" :key="idx" :value="cashPMode.pmodeID">{{ cashPMode.mode }}</option>
                </select>
            </template>
        </tail-select>
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'paymentModeID').length">
            {{ errors.filter(error => error.field == 'paymentModeID')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-1">
        <label for="grid-tendered" class="label-control">Tendered:</label>
        <input type="number" 
            v-model.number="tendered"
            min="0" id="grid-tendered"
            class="input-control input-sm text-xs text-right">
    </div>
    <div class="md:w-1/3 sm:w-full p-1">
        <label for="grid-tendered" class="label-control">Amount:</label>
        <input type="number" 
            v-model.trim.number="cashSale.totalCashAmount" 
            min="0" id="grid-tendered" disabled
            class="input-control input-sm text-xs text-right disabled">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'totalCashAmount').length">
            {{ errors.filter(error => error.field == 'totalCashAmount')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-1">
        <label for="grid-tendered" class="label-control">Change:</label>
        <input type="number"
            :value="tendered-cashSale.totalCashAmount"
            min="0" id="grid-tendered" disabled
            class="input-control input-sm text-xs text-right disabled">
    </div>
    <div class="md:w-2/3 sm:w-full p-1">
        <label for="grid-memo" class="label-control">Memo:</label>
        <input type="text" v-model.trim="cashSale.memo" id="grid-memo" class="input-control input-sm text-xs">
    </div>
</div>
</template>
